import {Component, inject} from '@angular/core';
import {DxTabsModule} from 'devextreme-angular';
import {AccessType, AuthService, PermissionType} from '@services';
import {MyScoreVendorsComponent} from './my-score-vendors/my-score-vendors.component';
import {MyScoreOperationsComponent} from './my-score-operations/my-score-operations.component';
import {MyScoreFinanceComponent} from './my-score-finance/my-score-finance.component';

enum TabType {
    Vendors = 'Vendors',
    Operations = 'Operations',
    Finance = 'Finance',
}

@Component({
    selector: 'app-invoicing-my-score',
    imports: [DxTabsModule, MyScoreVendorsComponent, MyScoreOperationsComponent, MyScoreFinanceComponent],
    templateUrl: './my-score.component.html',
})
export class InvoicingMyScoreComponent {
    private auth = inject(AuthService);

    protected readonly TabType = TabType;

    protected readonly canViewVendors = this.auth.checkPermission(PermissionType.MyScoreVendors, AccessType.ViewOnly);
    protected readonly canViewOperations =
        this.auth.checkPermission(PermissionType.MyScoreOperationsL1, AccessType.ViewOnly)
        || this.auth.checkPermission(PermissionType.MyScoreOperationsL2, AccessType.ViewOnly)
        || this.auth.checkPermission(PermissionType.MyScoreOperationsL3, AccessType.ViewOnly);
    protected readonly canViewFinance =
        this.auth.checkPermission(PermissionType.MyScoreFinanceInvoices, AccessType.ViewOnly)
        || this.auth.checkPermission(PermissionType.MyScoreCreditRequests, AccessType.ViewOnly);

    protected readonly tabs = [
        ...(this.canViewVendors ? [{type: TabType.Vendors, text: 'Vendors'}] : []),
        ...(this.canViewOperations ? [{type: TabType.Operations, text: 'Operations'}] : []),
        ...(this.canViewFinance ? [{type: TabType.Finance, text: 'Finance'}] : []),
    ];

    protected selectedTab: TabType = this.tabs[0].type;

    protected onTabClick(type: TabType): void {
        this.selectedTab = type;
    }
}
